import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { Global, css } from '@emotion/core';
import PropTypes from 'prop-types';

import encode from '../../../../shared/utils/encodeToUrl';
import { LoginSchema } from '../../../../shared/utils/loginSchemaHelper';
import SharedLoginForm from '../../../login/components/shared/SharedLoginForm';
import useLogin from '../../../login/components/hooks/useLogin';

const LoginModal = ({
  openModal,
}) => {
  const {
    handleLogin,
  } = useLogin();

  const [googleLoginWidth, setGoogleLoginWidth] = useState('360');

  useEffect(() => {
    const handleResize = () => {
      setGoogleLoginWidth(window.innerWidth < 400 ? '270' : '360');
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Formik
      initialValues={{
        password: '',
        username: '',
      }}
      onSubmit={(values) => {
        const submissionObject = {
          client_id: process.env.CLIENT_ID,
          client_secret: process.env.CLIENT_SECRET,
          grant_type: 'password',
          password: values.password,
          scope: 'offline_access',
          username: values.username,
        };
        handleLogin(encode(submissionObject));
      }}
      validationSchema={LoginSchema}
      render={({
        errors,
        touched,
        handleSubmit,
        values,
      }) => (
        <>
          <Global
            styles={css`
              .ReactModal__Content {
                width: 420px!important;
              }
            `}
          />
          <SharedLoginForm
            errors={errors}
            googleLoginWidth={googleLoginWidth}
            handleNoAccountClick={() => openModal('createAccount')}
            handleSubmit={handleSubmit}
            touched={touched}
            values={values}
          />
        </>
      )}
    />
  );
};

LoginModal.propTypes = {
  openModal: PropTypes.func.isRequired,
};

export default LoginModal;
